<template>
  <section class="facility-hero">
    <div class="section-inner">
      <!-- ---------- LEFT : TEXT ---------- -->
      <div class="si-left">
        <h2 class="facility-name">{{ facilityName }}</h2>
        <p class="facility-tagline">
          Rumah Sakit Khusus Jantung dan Pembuluh Darah Melinda Cardio Vascular Center memiliki Tim Dokter berpengalaman yang selalu siap memberikan perawatan kesehatan terbaik untuk Anda.
        </p>

        <!-- ---------- CONTACT LIST (inside left column) ---------- -->
        <ul class="si-contacts">
          <li class="contact-item" v-for="c in contacts" :key="c.title">
            <div class="icon-circle">
              <img :src="c.icon" alt="" aria-hidden="true" />
            </div>
            <div class="contact-text">
              <h3>{{ c.title }}</h3>
              <p v-html="c.value" />
            </div>
          </li>
        </ul>
      </div>

      <!-- ---------- RIGHT : HERO IMAGE (hidden on ≤ 1270 px) ---------- -->
      <div class="si-right" aria-hidden="true">
        <img src="../../assets/images/pictures/mcvcgt.png" alt="Petugas Melinda CVC" />
      </div>
    </div>
  </section>
</template>

<script setup>
import { facilityName } from '@/data/settings'

const contacts = [
  {
    title: 'Hunting',
    value: '(022) 6319 9888',
    icon: new URL('../../assets/images/icons/phonehollow.png', import.meta.url).href
  },
  {
    title: 'IGD',
    value: '(022) 4226 5911',
    icon: new URL('../../assets/images/icons/phonehollow.png', import.meta.url).href
  },
  {
    title: 'Pendaftaran',
    value: '0813 1284 5500 <br/>(Call & WhatsApp)',
    icon: new URL('../../assets/images/icons/waicon.png', import.meta.url).href
  }
]
</script>

<style scoped>
/******************* Layout *******************/
.facility-hero {
  background: var(--navy);
  color: var(--white);
}
.section-inner {
  display: grid;
  grid-template-columns: 40% 60%;
  min-height: 480px;
  transition: 0.2s;
}

/******************* Text block *******************/
.si-left {
  position: relative;
  padding: 4rem 10% 7rem 10%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  transition: 0.2s;
}
.si-left h2{
    font-size: 2rem;
}
.facility-name {
  font-family: poppins;
  font-size: 2.25rem;
  margin: 0;
  color: var(--cream);
}
.facility-tagline {
  font-size: 1.125rem;
  line-height: 1.6;
  text-align: justify;
  margin: 0;
}

/******************* Image *******************/
.si-right {
  overflow: hidden;
  transition: 0.2s;
}
.si-right img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/******************* Contact list *******************/
.si-contacts {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 2rem;
  padding: 0 10%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem 1.5rem;
  list-style: none;
  margin: 0;
}
.contact-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.icon-circle {
  flex-shrink: 0;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: #ffffff33;
  display: grid;
  place-items: center;
}
.icon-circle img {
  width: 60%;
}
.contact-text h3 {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 600;
}
.contact-text p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.3;
}

/******************* Responsive *******************/
@media (max-width: 1500px){
    .si-left{
        padding: 4rem 5% 7rem 5%;
    }
    .si-contacts{
        padding: 0 5%;
    }
}
@media (max-width: 1270px) {
  .section-inner {
    grid-template-columns: 1fr;
  }
  .si-right {
    display: none;
  }
  .si-left {
    padding: 3rem 5% 6.5rem;
  }
  .si-contacts {
    padding: 0 5%;
  }
  .facility-name {
    font-size: 2rem;
  }
}
@media (max-width: 750px) {
  .si-left {
    padding: 2.5rem 2.5% 6rem;
  }
    .si-left h2{
        font-size: 1.5rem;
    }
  .si-contacts {
    grid-template-columns: 1fr;
    padding: 0 2.5%;
  }
  .icon-circle{
    width: 25px;
    height: 25px;
  }
}
@media (max-width: 650px) {
  .section-inner {
    min-height: 560px;
  }
  .si-contacts {
    bottom: 1rem;
  }
}
@media (max-width: 350px){
    .section-inner {
        min-height: 650px;
    }
}
</style>
